module.exports = __webpack_public_path__ + "img/summary.ae36d0ac.png";